import { render, staticRenderFns } from "./OnePointToFiles.vue?vue&type=template&id=2101325f&scoped=true"
import script from "./OnePointToFiles.vue?vue&type=script&lang=js"
export * from "./OnePointToFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2101325f",
  null
  
)

export default component.exports